<mat-menu #menu="matMenu" [class]="panelClass">
  <div class="breadcrumb-menu-search" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <i class="ri-search-line"></i>
    <!-- Value-bound because the panel is not re-created per open: clearing the term has to
         clear the box too. -->
    <input #searchInput type="text" [placeholder]="'label.search' | translate" [value]="search"
      (input)="search = searchInput.value" />
  </div>
  <div class="breadcrumb-menu-list">
    <ng-container *ngIf="options; else loadingState">
      <ng-container *ngFor="let option of visibleOptions; trackBy: trackByOptionId">
        <ng-container *ngIf="option.expandable; else leafRow">
          <!-- The child panel, declared next to its trigger so `#child` resolves here. -->
          <ts-navigation-breadcrumb-menu #child [options]="option.children" [panelClass]="panelClass"
            [path]="pathWith(option)" [activeIds]="activeIds" [emptyKey]="option.emptyKey ?? null"
            (optionSelected)="optionSelected.emit($event)" (optionExpanded)="optionExpanded.emit($event)">
          </ts-navigation-breadcrumb-menu>
          <button mat-menu-item class="breadcrumb-menu-parent" [matMenuTriggerFor]="child.menu"
            [class.active]="isActive(option)" (menuOpened)="optionExpanded.emit({
              levelKey: levelKeyOf(option),
              optionId: option.id,
              path: pathWith(option)
            })" (menuClosed)="child.resetSearch()">
            <ng-container *ngTemplateOutlet="row; context: { $implicit: option }"></ng-container>
          </button>
        </ng-container>

        <!-- Leaf: the deepest level of the chain, and the only one that commits. -->
        <ng-template #leafRow>
          <button mat-menu-item [class.active]="isActive(option)" (click)="optionSelected.emit({
              levelKey: levelKeyOf(option),
              optionId: option.id,
              path: pathWith(option)
            })">
            <ng-container *ngTemplateOutlet="row; context: { $implicit: option }"></ng-container>
          </button>
        </ng-template>
      </ng-container>
      <div class="breadcrumb-menu-empty" *ngIf="visibleOptions.length === 0">
        {{ (emptyKey || 'label.no_results') | translate }}
      </div>
    </ng-container>
    <ng-template #loadingState>
      <div class="breadcrumb-menu-empty">{{ 'info.loading_data' | translate }}</div>
    </ng-template>
  </div>
</mat-menu>

<ng-template #row let-option>
  <i class="ri-check-line breadcrumb-menu-check" [class.invisible]="!isActive(option)"></i>
  <span *ngIf="option.indicator as indicator" class="breadcrumb-indicator"
    [ngClass]="'breadcrumb-indicator--' + indicator.kind" [matTooltip]="indicator.tooltip"></span>
  <span class="breadcrumb-menu-label">{{ option.name }}</span>
  <small class="breadcrumb-menu-hint" *ngIf="option.hint">{{ option.hint }}</small>
  <span class="breadcrumb-menu-badge" *ngIf="option.badge">{{ option.badge }}</span>
</ng-template>
